module.exports = {"id":"180754","name":"Kengo Nakamura","rating":"73","photo":"./data/images/photos/2/180754.png","club":{"name":"Kawasaki Front.","logo":"./data/images/clubs/KawasakiFront..png"},"positions":["MOC","MC","MDC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KengoNakamura0.json
// module id = 2324
// module chunks = 0